module.exports = __webpack_public_path__ + "media/public/img/profile-bg-2fbc94b55695ee5f1b40d234be944893.png";